import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpireSquad} from '@tisa-group/models';

@Injectable()
export class SquadStatsService implements CrudService<UmpireSquad> {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSquad>> {
    return this.http
      .get(`/squads/${fetchIdentifier}/stats`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
